export default {
    labels: {
        title: 'Relação de envio',
        searchBar: 'Pesquise por número de relação de envio ou número da nota fiscal',
        statuses: 'Status',
        originInvoiceGroupId: 'Número de relação de envio',
        path: 'Diretório',
        status: 'Status',
        settlementNumber: 'Protocolo',
        detailTitle: 'Detalhe da relação de envio',
        generalInformation: 'Informações gerais',
        files: 'Copiar arquivos',
        invoices: 'Contas',
        extension: 'Extensão',
        fileName: 'Nome do arquivo',
        invoiceNumber: 'Número da fatura',
        packageStatus: 'Status do pacote',
        externalId: 'Guia',
        actions: 'Ações',
        packageFolderConfiguration: 'Configuração da pasta',
        generateAccountButton: 'Gerar relação de envio',
        reGenerateAccountButton: 'Regerar relação de envio',
    },
    dialogText: {
      generateAccount: {    
        title: 'Deseja gerar a relação de envio?',
        subtitle: 'Esta relação de envio tem ({count}) fatura para gerar. Tem certeza de que deseja prosseguir? Esta ação não pode ser desfeita ou interrompida. | Esta relação de envio tem ({count}) faturas para gerar. Tem certeza de que deseja prosseguir? Esta ação não pode ser desfeita ou interrompida.',
      },
      preSettlementAction: {
        title: 'Você deseja executar essa ação com as faturas dessa relação de envio?',
        subtitle: 'Esta relação de envio tem ({count}) fatura para enviar. Tem certeza de que deseja prosseguir? | Esta relação de envio tem ({count}) faturas para enviar. Tem certeza de que deseja prosseguir?',
      },
      preSettlementRipsValidationErrors: {
        title: 'Deseja atualizar o status da relação de envio?',
        subtitle: 'Esta relação de envio será marcada com o status Erro de validação de arquivo RIPS. Tem certeza de que deseja prosseguir?',
      }
    },
    statuses: {
        PENDING: 'Pendente',
        READY_TO_GENERATE: 'Pronto para gerar',
        GENERATED: 'Gerado',
        SETTLED: 'Liquidado',
        SENT: 'Enviado',
        VOIDED: 'Cancelado',
        RIPS_VALIDATION_ERRORS: 'Erro de validação do arquivo RIPS'
    },
    actions: {
      setAccountsAsPackageGenerated: 'Definir como Gerado',
      setAccountsAsSettled: 'Definir como Liquidada',
      setAccountsAsSent: 'Definir como Enviada para Liquidar',
      setAccountsAsRipsValidationErrors: 'Definir como Erro de validação do arquivo RIPS',
    },
    errors: {
        downloadFile: 'Ocorreu um erro ao baixar o arquivo. Tente novamente ou entre em contato com sua equipe de suporte técnico.',
    },
    package: {
      globalConfigurationHint: 'Esta configuração se aplica a todos os convênios que não possuem uma rota específica',
      configurationByAgreement: 'Configuração por convênio',
      generalConfiguration: 'Configurações gerais',
      addConfigurationByAgreement: 'Adicionar configuração por convênio',
      deleteWarning: 'Tem certeza de que deseja excluir a configuração?',
      deleteWarningMessage: 'A configuração será substituída pela configuração geral',
      duplicatedAgreement: 'Você tem certeza de que deseja substituí-lo? Isso alterará a configuração de arquivamento do convênio {agreementCodes}',
      headers: {
        agreementCodes: 'Código do convênio',
        path: 'Diretório',
        actions: 'Ações'
      }
    }
}
